import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import Image from '../../atoms/Image';

export default function ContentImage({ width, ...imageProps }) {
  return (
    <Grid.Column width={width}>
      <Image {...imageProps} />
    </Grid.Column>
  );
};

ContentImage.propTypes = {
  width: PropTypes.string,
};

ContentImage.defaultProps = {
  width: undefined,
};
